module.exports = __webpack_public_path__ + "media/images/faramia/objectif-4492590eeb8d6a18f01de725400c583c.png";